import { defineMessages } from 'react-intl';

export default defineMessages({
    premium: {
        id: 'gateway.directives.PolicySummary.Premium',
        defaultMessage: 'Premium',
    },
    openQuoteLabel: {
        id: 'gateway.directives.job-summary.Start New Quote',
        defaultMessage: 'Start New Quote',
    },
    openQuoteHeading: {
        id: 'gateway.directives.job-summary.Quote',
        defaultMessage: 'Quote',
    },
    openQuotesSearchQuotesLabel: {
        id: 'gateway.directives.job-summary.Search quotes',
        defaultMessage: 'Search quotes',
    },
    openQuotesLastDaysLabel: {
        id: 'gateway.views.quote-detail.last30Days',
        defaultMessage: 'Issued in Last 30 Days',
    },
    openQuotesOpenNotBoundLabel: {
        id: 'gateway.views.quote-detail.openNotBound',
        defaultMessage: 'Open - Not Bound',
    },
    openQuotesOpenBoundLabel: {
        id: 'gateway.views.quote-detail.openBound',
        defaultMessage: 'Open - Bound',
    },
    openQuotesCreatedLabel: {
        id: 'gateway.directives.job-summary.Created',
        defaultMessage: 'Created',
    },
    openQuotesProductLabel: {
        id: 'gateway.directives.job-summary.Line',
        defaultMessage: 'Product',
    },
    openQuotesPremiumLabel: {
        id: 'gateway.directives.job-summary.Cost',
        defaultMessage: 'Premium',
    },
    openQuoteStatusLabel: {
        id: 'gateway.directives.job-summary.Status',
        defaultMessage: 'Status',
    },
    noQuotesLabel: {
        id: 'gateway.directives.job-summary.There are no quotes meeting these filters',
        defaultMessage: 'There are no quotes meeting these filters',
    },
    noQuoteForAccount: {
        id: 'gateway.directives.job-summary.There are no open quotes for this account.',
        defaultMessage: 'There are no open quotes for this account.',
    },
    allStatus: {
        id: 'ent.gateway.views.quote-detail.All',
        defaultMessage: 'All'
    },
    draftStatus: {
        id: 'ent.gateway.views.quote-detail.Draft',
        defaultMessage: 'Draft'
    },
    quotedStatus: {
        id: 'ent.gateway.views.quote-detail.Quoted',
        defaultMessage: 'Quoted'
    },
    expiredStatus: {
        id: 'ent.gateway.views.quote-detail.Expired',
        defaultMessage: 'Expired'
    },
    offerSubmittedStatus: {
        id: 'ent.gateway.views.quote-detail.Offer Submitted',
        defaultMessage: 'Offer Submitted'
    },
    policyType: {
        id: 'ent.gateway.directives.job-summary.POlicy Type',
        defaultMessage: 'POlicy Type'
    },
    effectiveDate: {
        id: 'ent.gateway.directives.job-summary.Effective Date',
        defaultMessage: 'Effective Date'
    }

});
